import {IController, IScope} from "angular";
import * as angular from "angular";
import {ServiceAreaRequests} from "../../../service-areas/services/service-area-requests.service";
import {DeliveriesDialogService} from "../../../deliveries/services/deliveries-dialog-service.service";
import {LeanPlanningAlertsService} from "../../services/lean-planning-alerts.factory";
import {LeanPlanningDialogService} from "../../services/lean-planning-dialogs-service.factory";
import {LeanPlanningRequestsService} from "../../services/plan-requests.factory";
import * as _ from "lodash";
import {RouteModel} from "../../../routes/models/route.model";

export class planningRoutesQueryListCtrl implements IController {
  range: any;
  checkedIds?: string[];
  checkedRoutes: RouteModel[];
  queryString: any;
  statuses: any;
  branchIds: any;
  serviceAreaIds: any;
  onSelect: Function;
  onCheckedChange: Function;

  public loadLimit: number = 30;
  public routesRef: any;
  public infiniteScroll: any;
  public selectedKeys: any;


  constructor(private $planningRoutes, private $infiniteScroll, private serviceAreaRequests: ServiceAreaRequests, private deliveriesDialogService: DeliveriesDialogService,
              private leanPlanningDialogService: LeanPlanningDialogService, private leanPlanningAlertsService: LeanPlanningAlertsService, private $scope: IScope, private leanPlanningRequestsService: LeanPlanningRequestsService, private $log) {
    this.routesRef = this.$planningRoutes();
  }


  $onInit() {
    this.routesRef.$query(this._getRoutesQuery());
    this.infiniteScroll = this.$infiniteScroll(this.routesRef, this.loadLimit);
  };


  $onChanges(changes) {

    if (changes.checkedIds) {
      this.selectedKeys = {};
      _.forEach(this.checkedIds, (id) => {
        this.selectedKeys[id] = true;
      })
    }

    if (changes.range && !changes.range.isFirstChange()) {
      this._loadRoutes();
    }

    if (changes.statuses && !changes.statuses.isFirstChange()) {
      this._loadRoutes();
    }

    if (changes.serviceAreaIds && !changes.serviceAreaIds.isFirstChange()) {
      this._loadRoutes();
    }

    if (changes.branchIds && !changes.branchIds.isFirstChange()) {
      this._loadRoutes();
    }

    if (changes.queryString && !changes.queryString.isFirstChange()) {
      this._loadRoutes();
    }

  };

  onToggle(route, isChecked) {
    this.onCheckedChange({
      routes: isChecked ? _.concat(this.checkedRoutes || [], [route]) :
        _.filter(this.checkedRoutes, (r) => {
          return r.id !== route.id;
        })
    });
  }

  // ******************************
  //        Internal methods
  // ******************************

  private _loadRoutes() {
    this.routesRef.$query(this._getRoutesQuery()).then(
      () => {
        this.infiniteScroll.reload();
      },
      (resp) => {
        this.$log.error('Fail to $query', resp);
      }
    );
  }

  private _getRoutesQuery() {
    return {
      expanded: false,
      query: this.queryString,
      from: this.range.dateStart,
      to: this.range.dateEnd,
      status: this.statuses,
      branchIds: this.branchIds,
      areaIds: this.serviceAreaIds,
      limit: this.loadLimit
    }
  }


}

angular
  .module('bringoz.admin.lean-planning')
  .component('planningRoutesQueryList', {
    bindings: {
      range: '<',
      checkedIds: '<?',
      checkedRoutes: '<?',
      queryString: '<',
      statuses: '<',
      branchIds: '<',
      serviceAreaIds: '<',
      onSelect: '&',
      onCheckedChange: '&'
    },
    template: require('./planning-routes-query-list.html').default,
    controller: planningRoutesQueryListCtrl
  });
